export const CustomMetrics = {
    name: 'VexFlowCustom',
    smufl: false,
    glyphs: {},
};
